import { render, staticRenderFns } from "./ProductoProveedorTable.vue?vue&type=template&id=7cb2c602&"
import script from "./ProductoProveedorTable.vue?vue&type=script&lang=js&"
export * from "./ProductoProveedorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports